export const CANVAS = 'C';
export const TYPED = 'T';
export const UPLOAD = 'U';
export const EMAIL = 'E';
